// extracted by mini-css-extract-plugin
module.exports = {"cajaInicioSesion":"landing_cajaInicioSesion__23HSR","boton":"landing_boton__3oyTA"};